import { render } from "./wJitsiMeet.vue?vue&type=template&id=8e9cabfe&ts=true"
import script from "./wJitsiMeet.vue?vue&type=script&lang=ts"
export * from "./wJitsiMeet.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__